import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { fetchSettings } from "@/lib/api";

function injectScript(id, build) {
  document.getElementById(id)?.remove();
  const el = build();
  if (el) document.head.appendChild(el);
}

export default function TrackingInjector() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    fetchSettings().then((s) => {
      // Google Search Console verification
      if (s.google_site_verification) {
        injectScript("gsc-verification", () => {
          const m = document.createElement("meta");
          m.id = "gsc-verification";
          m.name = "google-site-verification";
          m.content = s.google_site_verification;
          return m;
        });
      }
      // Google Analytics 4
      if (s.ga_measurement_id && !window.__gaLoaded) {
        window.__gaLoaded = true;
        injectScript("ga-src", () => {
          const sc = document.createElement("script");
          sc.id = "ga-src";
          sc.async = true;
          sc.src = `https://www.googletagmanager.com/gtag/js?id=${s.ga_measurement_id}`;
          return sc;
        });
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag("js", new Date());
        window.gtag("config", s.ga_measurement_id);
      }
      // Meta Pixel
      if (s.meta_pixel_id && !window.__fbqLoaded) {
        window.__fbqLoaded = true;
        const n = (window.fbq = window.fbq || function () { n.queue.push(arguments); });
        n.queue = n.queue || [];
        n.loaded = true;
        n.version = "2.0";
        injectScript("meta-pixel", () => {
          const sc = document.createElement("script");
          sc.id = "meta-pixel";
          sc.async = true;
          sc.src = "https://connect.facebook.net/en_US/fbevents.js";
          return sc;
        });
        window.fbq("init", s.meta_pixel_id);
        window.fbq("track", "PageView");
      }
    });
  }, [pathname]);

  return null;
}
